import React from "react";
import { Table } from "semantic-ui-react";
import NotificationsListItem from "./NotificationsListItem";

export default function NotificationsList({
  notifications,
  docsWithComments = [],
  weeklyDeadlineSuggestions = [],
}) {
  // Combine notifications and documents with unresolved comments
  const allItems = [
    ...(notifications || []),
    ...docsWithComments.map(doc => ({
      ...doc,
      type: "unresolvedComments",
      _isDocumentComment: true,
    })),
    ...weeklyDeadlineSuggestions,
  ];

  return (
    <>
      <Table compact>
        <Table.Header className="mobile hidden">
          <Table.Row className="small-header">
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Transaction</Table.HeaderCell>
            <Table.HeaderCell>From</Table.HeaderCell>
            <Table.HeaderCell>Message</Table.HeaderCell>
            <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {allItems && allItems.length > 0 ? (
            allItems.map((notification) => (
              <NotificationsListItem
                notification={notification}
                key={notification.id}
              />
            ))
          ) : (
            <Table.Row>
              <Table.Cell colSpan="6">
                <p>No notifications</p>
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </>
  );
}

